import { Settings } from '../../../domain';
import { GeneralTranslations } from '../types';

type TranslationConfig = {
  settingsKey?: keyof Settings;
  fallback?: string;
};

/**
 * Configuration mapping translation keys to their settings keys and optional fallbacks
 */
export const TRANSLATION_CONFIG: Record<
  keyof GeneralTranslations,
  TranslationConfig
> = {
  and_select_one_of_the_free_gifts: {
    settingsKey: 'and_select_one_of_the_free_gifts',
  },
  buy_any_product_from_the_collection: {
    settingsKey: 'buy_any_product_from_the_collection',
  },
  buy_product: { settingsKey: 'buy_product' },
  buy_reqproductq_products_from_the_collection: {
    settingsKey: 'buy_reqproductq_products_from_the_collection',
  },
  buy_reqproductq_products: { settingsKey: 'buy_reqproductq_products' },
  custom_free_gift: { settingsKey: 'custom_free_gift' },
  discount_correct_info: { settingsKey: 'discount_correct_info' },
  discount_incorrect_info: { settingsKey: 'discount_incorrect_info' },
  discount_page_header: { settingsKey: 'discount_page_header' },
  discount_prompt: { settingsKey: 'discount_prompt' },
  discount_section_button: {
    settingsKey: 'discount_section_button',
    fallback: 'Apply',
  },
  discount_section_discount: {
    settingsKey: 'discount_section_discount',
    fallback: 'Discount',
  },
  discount_section_subtotal: { settingsKey: 'subtotal', fallback: 'Subtotal' },
  discount_section_total: { settingsKey: 'total', fallback: 'Total' },
  discount_title: { settingsKey: 'discount_title' },
  dont_miss_your_reward: { settingsKey: 'dont_miss_your_reward' },
  free_shipping: { settingsKey: 'free_shipping' },
  gift_product_prefix: { settingsKey: 'gift_product_prefix' },
  select_your_free_gift: { settingsKey: 'select_your_free_gift' },
  spend_remainingspend_in_the_collection: {
    settingsKey: 'spend_remainingspend_in_the_collection',
  },
  spend_remainingspend_more_in_the_collection: {
    settingsKey: 'spend_remainingspend_more_in_the_collection',
  },
  spend_remainingspend_more: { settingsKey: 'spend_remainingspend_more' },
  spend_remainingspend: { settingsKey: 'spend_remainingspend' },
  subtitle_condition_met: { settingsKey: 'subtitle_condition_met' },
  subtitle: { settingsKey: 'subtitle' },
  title_condition_met: { settingsKey: 'title_condition_met' },
  title: { settingsKey: 'title' },
  to_get_a_free_displayname: { settingsKey: 'to_get_a_free_displayname' },
  to_get_a_free_gift: { settingsKey: 'to_get_a_free_gift' },
  to_get_free_shipping: { settingsKey: 'to_get_free_shipping' },
};
